module.exports = __webpack_public_path__ + "static/media/join-us.99cac416.png";